import cls from 'classnames'
import { ChangeEvent } from 'preact/compat'
import { h, FunctionComponent } from 'preact'
import { useContext } from 'preact/hooks'

import FieldsContext from 'components/business/SurveyForm/Fields/fieldsContext'

import classes from './option.scss'

type OptionProps = {
  value: string
  type: 'checkbox' | 'radio'
  className?: string
  checked?: boolean
  onChange?: (value: string, checked: boolean) => void
  disabled?: boolean
}

const Option: FunctionComponent<OptionProps> = (props) => {
  const { windowSizeSm } = useContext(FieldsContext)!
  const { checked = false, type, className = '', value, children, onChange, disabled, ...restProps } = props

  const classNames = cls(
    classes.option,
    classes[type],
    !windowSizeSm && classes.webOption,
    windowSizeSm && classes.sm,
    className,
    {
      [classes.checked]: checked,
      [classes.disabled]: disabled,
    }
  )

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    // @ts-ignore
    const { checked, value } = event.target!
    if (!checked && type === 'radio') return
    onChange?.(value, checked)
  }

  return (
    <label className={classNames} disabled={disabled}>
      <span className={classes.optionWrapper}>
        <input
          disabled={disabled}
          type={type}
          className={classes.optionInput}
          checked={checked}
          value={value}
          onChange={handleChange}
          {...restProps}
          data-testid="checkbox"
        />
        <span className={classes.optionInner} />
      </span>
      {children && <span className={classes.optionText}>{children}</span>}
    </label>
  )
}

export default Option
